import { userApi as api } from './userApi';
export const addTagTypes = ['Users'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: queryArg => ({
          url: `/users`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            userId: queryArg.userId
          }
        }),
        providesTags: ['Users']
      }),
      addUsers: build.mutation<AddUsersApiResponse, AddUsersApiArg>({
        query: queryArg => ({
          url: `/users`,
          method: 'POST',
          body: queryArg.createUsers
        }),
        invalidatesTags: ['Users']
      }),
      getUsersById: build.query<GetUsersByIdApiResponse, GetUsersByIdApiArg>({
        query: queryArg => ({ url: `/users/${queryArg.id}` }),
        providesTags: ['Users']
      }),
      updateUsers: build.mutation<UpdateUsersApiResponse, UpdateUsersApiArg>({
        query: queryArg => ({
          url: `/users/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateUsers
        }),
        invalidatesTags: ['Users']
      }),
      deleteUsers: build.mutation<DeleteUsersApiResponse, DeleteUsersApiArg>({
        query: queryArg => ({
          url: `/users/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Users']
      }),
      forgotPassword: build.mutation<
        ForgotPasswordApiResponse,
        ForgotPasswordApiArg
      >({
        query: queryArg => ({
          url: `/forgotPassword`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Users']
      }),
      postForgotPassword: build.mutation<
        PostForgotPasswordApiResponse,
        PostForgotPasswordApiArg
      >({
        query: queryArg => ({
          url: `/postForgotPassword`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Users']
      }),
      me: build.query<MeApiResponse, MeApiArg>({
        query: () => ({ url: `/me` }),
        providesTags: ['Users']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetUsersApiResponse = /** status 200 Users found. */ {
  ok?: boolean;
  data?: Users;
  message?: string;
};
export type GetUsersApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** userId */
  userId?: string;
};
export type AddUsersApiResponse =
  /** status 201 Users has been created successfully. */ {
    ok?: boolean;
    data?: Users;
    message?: string;
  };
export type AddUsersApiArg = {
  /** Users that needs to be added to the application */
  createUsers: CreateUsers;
};
export type GetUsersByIdApiResponse = /** status 200 Users details found. */ {
  ok?: boolean;
  data?: Users;
  message?: string;
};
export type GetUsersByIdApiArg = {
  /** ID of the Users to retrieve */
  id: string;
};
export type UpdateUsersApiResponse =
  /** status 200 The Users's details has been updated successfully */ {
    ok?: boolean;
    data?: Users;
    message?: string;
  };
export type UpdateUsersApiArg = {
  /** ID of the Users to update */
  id: string;
  /** Users that needs to be added to the application */
  updateUsers: UpdateUsers;
};
export type DeleteUsersApiResponse =
  /** status 200 The Users's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteUsersApiArg = {
  /** ID of the Users to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type ForgotPasswordApiResponse =
  /** status 200 The Users's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type ForgotPasswordApiArg = {
  /** Email address of the user */
  body: {};
};
export type PostForgotPasswordApiResponse =
  /** status 200 The Users's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type PostForgotPasswordApiArg = {
  /** Email address of the user */
  body: {};
};
export type MeApiResponse =
  /** status 201 Users has been created successfully. */ {
    ok?: boolean;
    data?: User;
    message?: string;
  };
export type MeApiArg = void;
export type Users = {
  count?: number;
  rows?: {
    email: string;
    password: string;
    fullName: string;
    planType: string;
    invited: string;
  }[];
};
export type CreateUsers = {
  email: string;
  password?: string;
  fullName?: string;
  planType?: string;
  invited?: string;
  cognitoUserName?: string;
};
export type UpdateUsers = {
  fullName?: string;
  isInvited?: string;
  isFirstLogin?: boolean;
  isVerified?: string;
  status?: string;
  cognitoUserName?: string;
};

export type User = {
  email: string;
  fullName: string;
  isInvited: string;
  isFirstLogin: boolean;
  userId: string;
  subscriberId: string;
};
export const {
  useGetUsersQuery,
  useAddUsersMutation,
  useGetUsersByIdQuery,
  useUpdateUsersMutation,
  useDeleteUsersMutation,
  useForgotPasswordMutation,
  usePostForgotPasswordMutation,
  useMeQuery
} = injectedRtkApi;
